import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Switch,
} from "@mui/material";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { I18n } from "aws-amplify/utils";
function ShowMailPopup({ isOpen, onClose, mailContent }) {
  const cleanHTML=DOMPurify.sanitize(mailContent);
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { width: "40%", maxWidth: "none" } }}
    >
      <DialogContent>
        <Box sx={{ mb: 1, fontSize: 18 }}>{parse(cleanHTML)}</Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose}>{I18n.get("Close")}</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

ShowMailPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mailContent: PropTypes.string.isRequired,
};

export default ShowMailPopup;
